import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { KeyCodes } from '@fluentui/react/lib/Utilities';
import { SurfaceEventHandlers } from 'owa-calendar-surface-dategrid';

/**
 * Event hanlers for overflow items on month view
 * @param command command to execute on click or enter
 */
export function createOverflowIndicatorEventHandlers(
    command: (surfaceItem: CalendarEvent, evt: React.SyntheticEvent<HTMLDivElement>) => void
): SurfaceEventHandlers {
    return {
        onClick: function (this: CalendarEvent, evt: React.MouseEvent<HTMLDivElement>) {
            command(this, evt);
        },
        onKeyDown: function (this: CalendarEvent, evt: React.KeyboardEvent<HTMLDivElement>) {
            switch (evt.which) {
                case KeyCodes.enter:
                    command(this, evt);
                    evt.preventDefault(); // this will prevent the enter key from clicking a button in the peek
                    break;
            }
        },
    };
}
